module.exports = __webpack_public_path__ + "static/img/PersonCategoryReduction.7cb660e3.png";